import { render, staticRenderFns } from "./AppendixFeeTrans.vue?vue&type=template&id=57fe7a75"
import script from "./AppendixFeeTrans.vue?vue&type=script&lang=js"
export * from "./AppendixFeeTrans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports